import React from 'react';
import { ParallaxProvider, Parallax } from 'react-scroll-parallax';
import './privacy_policy.css'; // You will add your styles here
import Footer2 from "../Home/newfooter";

const PrivacyPolicy = () => {
    return (
        <>
        <ParallaxProvider>
            <div className="privacy-policy-container">
                <section className="privacy-section">
                    <Parallax className="parallax-effect" y={[-20, 20]}>
                        <h2>Privacy Policy</h2>
                    </Parallax>
                    <p>
                        The Privacy Policy depicts our works on concerning the data gathered by U.S.
                        Car Parts Network, Inc. (“we or “us”) using vanderenginestransmission.com (the “Site”). We
                        perceive the significance of keeping up your protection. We esteem our association
                        with you and we value the trust you appear in giving data to us. Clarifying how we
                        gather, utilize and ensure client data is, in this way, of most extreme significance
                        to us.
                    </p>
                    <p>
                        This Privacy Policy is intended to disclose to you how we gather and utilize individual
                        data (as characterized beneath) so you can settle on an educated choice about utilizing
                        the Sites. If you don’t mind read this announcement before utilizing the Sites or
                        presenting any close to home data to us. We claim all authority to change the arrangements
                        of this Privacy Policy whenever. We will advise you of these progressions by posting a
                        reconsidered Privacy Policy on the Sites and showing on the Privacy Policy the date it
                        was last refreshed. Your utilization of the Sites following the posting of such changes
                        or overhauled articulation will comprise your agreement to any such changes. We urge
                        you to survey our Privacy Policy at whatever point you visit our Sites to decide whether
                        any progressions have been made and to ensure that you see how any close to home data
                        you give will be utilized. For a portrayal of the latest changes to this Privacy Policy,
                        allude to the area entitled “Changes to this Privacy Policy” beneath.
                    </p>
                    <p>Kindly Read This Privacy Policy Carefully. By Using This Sites, You Agree To Be Bound
                        By This Privacy Policy Described Herein, And All Updates Thereto And All Additional
                        Terms, Guidelines, And Disclosures Incorporated By Reference. You Accept This Privacy
                        Policy By Actually Using The Sites Or Its Services. In This Case, You Understand And
                        Agree That We Will Treat Your Use Of The Sites As Acceptance Of This Privacy Policy
                        From That Point Onwards.</p>
                    <p>
                        This Privacy Policy applies to the entirety of the product, items, and administrations
                        offered by us or any of our auxiliaries or partnered organizations through the Sites.
                        On the off chance that you have any inquiries concerning this Privacy Policy,
                        or to quit getting any messages or advancements from us, it would be ideal
                        if you don’t hesitate to reach us through the Sites or keep in touch with us at:
                    </p>
                    <p>
                        Vander Engines Protection Policy vanderenginestransmission.com 430, E 162nd St, South Holland, IL,60473
                    </p>
                    <p>
                        Our comprehensive Terms & Conditions include covering labor costs for up to six hours,
                        which can be utilized once, and mandate no order cancellations with a 25% restocking
                        fee applicable. Damages to engines or transmissions must be documented upon delivery
                        to qualify for refunds, and once sold, all transactions are final, with warranty void
                        if items are disassembled. Defective units must be returned within 15 days for
                        warranty validation, and while mileage certification is not provided, customers
                        acknowledge a binding agreement without rights to dispute credit card charges.
                        Transmissions are guaranteed operational upon purchase, no returns are accepted
                        for incorrect parts, and installations of engines or transmissions must occur
                        within two weeks, with a 30-day window for replacements. Electrical parts are
                        sold without warranty, installations require certified mechanics, and adherence
                        to manufacturer's guidelines is mandatory for fluid changes, seal replacements,
                        filter installations, and belt and hose replacements.
                    </p>
                </section>

                <section className="privacy-section">
                    <Parallax className="parallax-effect" y={[-20, 20]}>
                        <h2>Privacy of Children</h2>
                    </Parallax>
                    <p>
                        WE DO NOT PUBLISH CONTENT THAT IS TARGETED TO CHILDREN.
                        In the event that YOU ARE UNDER THIRTEEN YEARS OF AGE, YOU ARE NOT PERMITTED TO
                        ACCESS THE SITES FOR ANY REASON. In the event that we discover that we have gathered
                        individual data from a youngster under age 13, we will erase that data as fast as
                        would be prudent. We emphatically prescribe that minors 13 years old or more seasoned
                        approach their folks for authorization before sending any data about themselves to
                        anybody over the web and we urge guardians to encourage their youngsters about safe
                        web use rehearses.
                    </p>
                </section>

                <section className="privacy-section">
                    <Parallax className="parallax-effect" y={[-20, 20]}>
                        <h2>Information Collected and “Cookies”</h2>
                    </Parallax>
                    <p>
                        This area of our Privacy Policy applies to all data gathered by or
                        submitted to the Sites. The data that we gather from you causes us to
                        customize and consistently enhance your shopping experience. You have
                        the choice not to give certain data; in any case, retaining data may
                        keep you from having the option to exploit a portion of our Sites’ highlights.
                    </p>
                    <p>
                        At the point when you visit our Sites, we consequently get and store any data you
                        enter on our Sites. For instance, you give data when you: look for an item; submit
                        a request; place a thing in your shopping basket; peruse our Sites; give data in
                        your record; speak with us by telephone, talk, or email; total a poll; or participate
                        in different communications with us. Because of those activities, you may supply us
                        with so much data as your: name, address, email address, telephone numbers, budgetary
                        data, (for example, charge card or comparable installment data), value-based data
                        (in view of your exercises on the Sites and substance you produce or that identifies
                        with your record), shipping data, charging data (and other data you give to buy or
                        ship a thing), network exchanges, talks, contest goals, correspondence through the
                        Sites, and correspondence sent to us. We utilize this data straightforwardly or by
                        implication through our colleagues to advertise items to you on the Sites and through
                        mail and email, do an inner inquiry on your inclinations, and to assist us with
                        bettering comprehend and serve you.
                    </p>
                    <p>
                        We likewise store particular kinds of data when you communicate with us on our Sites.
                        For instance, we use “treats” and can get certain data from your internet browser.
                        By moving these alphanumeric identifiers or “treats” that your program makes at our
                        solicitation is an endorsed and institutionalized spot on your PC, we dole out you a
                        one of a kind client code and records data about your movement on our Sites. At the
                        point when you visit or come back to our Sites, we read the treat to recognize you
                        as one of our clients and assist you with reviewing requests or inclinations you
                        have chosen. The treat additionally empowers us to review your past exercises,
                        post your record information, send email to you, and tailor the Sites’ components
                        and data in an unequivocal manner, be that as it may, we might have the option to
                        distinguish you utilizing data acquired from outsiders. We utilize this data to
                        break down patterns, oversee the Sites, track clients’ developments around the Sites,
                        accumulate statistic data about our client base, and direct our promoting efforts.
                        Most internet browsers acknowledge treats as a matter of course yet enable clients
                        to dismiss treats by changing the program inclinations. On the off chance that you
                        have set up your program to dismiss treats, a few parts of our Sites, including our
                        Shopping Cart, won’t work appropriately. This Privacy Policy covers the utilization
                        of treats by us just and doesn’t cover the utilization of treats by any outsiders.
                        To quit having non-individual data or treats utilized by outsider specialist co-ops.
                    </p>
                    <p>
                        At whatever point you collaborate with us and our Sites, we gather, store, and examine
                        a few information about you, which may incorporate the full Uniform Resource Locator
                        (URL) clickstream to, through and from our Sites, including date and time; treat number;
                        items you saw or scanned for or set in your shopping basket; and the telephone number
                        you used to call our 800 number. Your IP address is utilized for inner utilize just and
                        encourages us to determine issues to have our server and direct our Sites.
                        We additionally consequently track certain data about your exercises on our Sites.
                        These may incorporate program type and form, working framework and stage,
                        measurements on online visits, traffic to and from the Sites, advertisement
                        information, standard web log data, and buy history. We utilize this data to
                        showcase items to you on the Sites and through mail and email, do interior research
                        on your inclinations, and to assist us with bettering comprehend and serve you.
                        We may interface this consequently gathered information to you by and by recognizable
                        data. We may gather and gauge session data, including page reaction times, download
                        mistakes, length of visits to specific pages, page collaboration data, (for example,
                        looking over, snaps, and mouse-overs), and strategies used to peruse away from the
                        page.
                    </p>
                    <p>
                        At the point when you buy items from us you are required to furnish us with your email
                        address and your conveyance address. We utilize your email address to keep you refreshed
                        on the status of your request. We utilize this to send you your request affirmation,
                        following numbers and other appropriate data about your request, for example, warnings on
                        delivery delays. You may likewise get item refreshes, suggestions, exceptional declarations
                        just as limits from our Sites through mail or email.
                        You can generally stop these showcasing exercises on
                        the withdraw connect found on each email we send you
                        or by contacting us through this connection. We regard
                        your security and will never lease or sell your email address to different
                        advertisers. We may likewise get data about you from different sources and add it to our
                        record data. Instances of these include: internet based life pages (for example Facebook)
                        ; refreshed conveyance and address data from our bearers or other outsiders
                        which we use to address our records and convey your next buy or correspondence all the
                        more effectively); site hit data from certain shippers with which we work for
                        co-marked organizations or for which we give specialized, satisfaction, promoting,
                        or different administrations; search term and output data including paid postings,
                        Supplemental Information got from outsiders may incorporate financial record data
                        from credit authorities and outsider Visa extortion discovery administrations,
                        hich we use to help counteract and distinguish misrepresentation. Likewise, if
                        the data you give can’t be checked, we may request that you send us extra data,
                        (for example, your driver’s permit, financial record, as well as an ongoing
                        service bill or other data affirming your location), or to respond to extra
                        addresses online to help confirm your data.
                    </p>
                </section>

                <section className="privacy-section">
                    <Parallax className="parallax-effect" y={[-20, 20]}>
                        <h2>Damaged Shipments</h2>
                    </Parallax>
                    <p>
                        After accepting your request, assess all transportation bundle/s and things
                        completely for indications of harmed, missing, or erroneous parts. Our stockrooms
                        apply all endeavors to avoid shipping harm, be that as it may, it occurs at times.
                        On the off chance that you happen to get a harmed part DO NOT acknowledge the bundle,
                        have the shipper promptly Return-To-Sender (RTS). On the off chance that the shipper
                        has left an harmed bundle in your nonappearance, quickly contact the transportation
                        organization and have the bundle come back to the sender. Likewise, you should call
                        us promptly if any of the above has struck keep you from being charged cargo on the
                        two different ways. We are not answerable for harmed, missing, or off base parts following
                        30 business days, paying little heed to which gathering is to blame. We are likewise not
                        answerable for lost or taken bundles and all cases from such episodes must be accounted
                        for and prepared through the delivery organization; see Risk Of Loss, underneath, for
                        extra data.
                    </p>
                </section>
                <section className="privacy-section">
                    <Parallax className="parallax-effect" y={[-20, 20]}>
                        <h2>Outsider Advertisers</h2>
                    </Parallax>
                    <p>
                        We utilize outsider publicizing organizations to email or serve promotions for our sake.
                        We may likewise serve advertisements or send an email which joins outsider treats or
                        activity labels. These treats or activity labels may follow your reaction to email or
                        ads and measure their viability or grant motivations or focuses to their individuals
                        who react to their ads. We have no entrance to or command over these treats or activity
                        labels. By utilizing these activity labels we don’t access any of your data gathered by
                        these promoters nor do we share any of your by and by recognizable data, for example,
                        your name, phone number or address with these organizations except if we or the publicist
                        generally tell you. If it’s not too much trouble click here so as to get familiar with the
                        data assortment practices of a portion of the outsider.
                    </p>
                </section>
                <section className="privacy-section">
                    <Parallax className="parallax-effect" y={[-20, 20]}>
                        <h2>Retargeting</h2>
                    </Parallax>
                    <p>
                        We are a piece of the Google AdWords Remarketing program. Google Remarketing may
                        dole out a treat to follow guests coming and leaving pages or zones of a site. This
                        data is then used to create a Remarketing List of guests that left the Sites from that
                        specific territory or page and might be utilized to tailor and serve advertisement
                        content on the Google Display Network that objectives these gatherings of clients.
                    </p>
                    <p>
                        We have no entrance to or power over these outsider treats and don’t access any of your
                        data gathered by Google nor does it share any of your actually recognizable data, for
                        example, your name, phone number, email, and personal residence with the Google Display
                        Network of destinations except if we or the site generally inform you. In the event that
                        you decide to tweak your advertisements inclinations or inside and out anticipate Google’s
                        utilization of treats during your perusing sessions, you may do as such by visiting the
                        Google Advertising Opt-out page. Then again, you may likewise decide to quit getting
                        treats from other outsider advertisement servers at the same time through the Network
                        Advertising Initiative (NAI) Opt-out Tool.
                    </p>
                </section>
                <section className="privacy-section">
                    <Parallax className="parallax-effect" y={[-20, 20]}>
                        <h2>Use of Information</h2>
                    </Parallax>
                    <p>
                        We pay attention to your security very. We don’t sell or lease your contact data to
                        different advertisers. Notwithstanding, we may share your data, including your by and
                        by recognizable data, to outsiders as set out in this Privacy Policy.
                    </p>
                    <p>
                        Offshoots. We may unveil the data we gather from you to our controlled associates or
                        backups and these substances may utilize the data for advertising purposes; be that as
                        it may, in the event that we do as such, the utilization and revelation of such data
                        will be dependent upon this Privacy Policy.
                    </p>
                    <p>
                        Specialist organizations. We may likewise make certain individual data about you
                        accessible to organizations that perform work for us to give items and administrations
                        to you for our benefit. These organizations may assist us with handling data, satisfy
                        client arranges, convey or advertise our items to you, oversee and upgrade client
                        information, or give client care. In such a circumstance, these organizations are
                        denied from utilizing your own data for any unapproved purposes and are additionally
                        committed to secure your data as per our arrangements, with the exception of in the
                        event that we advise you generally at the hour of assortment. Without such data being
                        made accessible, it would be hard for you to buy items, have items conveyed to you,
                        gets client support, or access certain administrations, offers, and substance on
                        our site. For instance, as a piece of the ordinary procedure of finishing your buy,
                        we may give your own information to an outsider installment processor, contingent
                        upon your picked strategy for installment. We additionally share data with outsiders,
                        for example, the U.S. Postal Service, Federal Express, and United Parcel Service to
                        send items and guarantee item conveyance
                    </p>

                    <p>
                    No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. 
                    All OPT-IN requests include text messaging originator opt-in data and consent; this information will not 
                    be shared with third parties.

                    </p>
                </section>
                <section className="privacy-section">
                    <Parallax className="parallax-effect" y={[-20, 20]}>
                        <h2>Secure Encryption</h2>
                    </Parallax>
                    <p>We utilize Secure Socket Layer (SSL) or TLS innovation, which is bolstered by
                        most by fa from present-day Internet programs. These work best when you are utilizing
                        the most recent encryption rendition of Internet programs. SSL and TLS innovation
                        speaks to the most significant level of security accessible on the Internet.
                        It consequently scrambles data going over the Internet, checks the character
                        of the executing servers through testaments and computerized marks, and affirms
                        that the trustworthiness of message content is kept up all through the transmission.
                    </p>
                    <p>
                        Our base prerequisite is SHA-256 piece SSL exchange encryption for Internet programs.
                        It would be ideal if you allude to your program’s documentation for data on its security
                        highlights. We transmit the scrambled Mastercard number to the suitable end installment
                        processor during request handling, yet we uncover just the last four digits of your charge
                        card numbers while affirming a request in consistence with Payment Card Industry Data
                        Security Standard.
                    </p>
                </section>
                <section className="privacy-section">
                    <Parallax className="parallax-effect" y={[-20, 20]}>
                        <h2>Credit Card Security</h2>
                    </Parallax>
                    <p>
                        Our servers utilize Secure Sockets Layer (SSL), an encryption innovation that works all
                        industry-standard programs. This guarantees no one but we can peruse your own data.
                        Charge card numbers are additionally encoded utilizing Public Keys and Private Key
                        calculations when transmitting by means of SSL giving an additional layer of assurance
                        onto SSL. We uncover just the last four digits of your charge card numbers while
                        affirming a request. We will be that as it may, transmit the whole Mastercard number
                        to the fitting end installment processor during request handling utilizing current
                        PCI prerequisites for Transport-level encryption. We have likewise acquired a
                        computerized authentication from Comodo Group, Inc, the main supplier of Internet
                        trust administrations. At the point when you enter a verified segment of our Sites,
                        a picture of a shut lock or a strong key ought to show up in the base bar of your
                        program window. On the off chance that you click on this picture, a little popup
                        window showing Site-security data will show up. This authentication ensures that
                        your own data is being transmitted in a protected (encoded) structure to our
                        Web server, not to an obscure or unapproved server
                    </p>
                    <p>
                        Our Sites are consistently tried and ensured to pass industry-driving outsider
                        security appraisal administration testing. This industry-standard outsider security
                        appraisal administration testing shields you from data fraud and charge card
                        misrepresentation. Eventually, your own data is secured by the secret key you
                        made when you enlisted for a record at our Sites on the “Sign In/Quick Checkout”
                        page. If it’s not too much trouble keep this secret word classified. None of our
                        agents will ever approach you for your secret phrase. The secrecy of your secret
                        key is yours to ensure.
                    </p>
                </section>
                <section className="privacy-section">
                    <Parallax className="parallax-effect" y={[-20, 20]}>
                        <h2>Information Security</h2>
                    </Parallax>
                    <p>
                        As per Section 1798.83 of the AL Civil Code, occupants of AL reserve the option to
                        demand from a business, with whom the AL inhabitant has a set up business relationship,
                        certain data concerning the kinds of individual data the business imparts to outsiders
                        for direct advertising purposes by such outsider and the characters of the outsiders
                        with whom the business has shared such data during the quickly going before schedule
                        year. To demand a duplicate of the data divulgence gave by us under Section 1798.83
                        of the AL Civil Code, it would be ideal if you keep in touch with us at:
                    </p>
                    <p>
                        Vander Engines Protection Policy vanderenginestransmission.com 1430, E 162nd St, South Holland, IL,60473 USA
                    </p>
                </section>
                <section className="privacy-section">
                    <Parallax className="parallax-effect" y={[-20, 20]}>
                        <h2>Changes to this Privacy Policy</h2>
                    </Parallax>
                    <p>
                        This Privacy Policy was keeping going altered on June 7, 2019. These progressions
                        explain that you may get promoting materials from us through both mails or potentially
                        email by the details of this Privacy Policy, just as explain how we may utilize treats
                        and activity labels to advertise our items to you. It would be ideal if you note that
                        this Privacy Policy may change whenever. We maintain all authority to change this
                        Privacy Policy whenever, so please audit it much of the time. We will post any Privacy
                        Policy changes on this page.
                    </p>
                </section>
            </div>
        </ParallaxProvider>
        <Footer2/>
        </>
    );
};

export default PrivacyPolicy;
